import { useEffect, useRef, useState } from 'react';
import {
  CreateEditAnnualReview,
  NotificationAlert,
  Table,
} from '../../../components';
import { useNavigate } from 'react-router-dom';
import { AnnualReviewCycle } from '../../../types/AnnualReview';
import { getAllAnnualReviewCycles } from '../../../services/annualServices';
import { Button, Modal } from 'antd';
import { Paths } from '../../../routes';
import { Columns } from './Columns';

const AllAnnualReviewCycles = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [editID, setEditID] = useState<string | null>(null);
  const [data, setData] = useState<AnnualReviewCycle[]>([]);
  const myRef = useRef<any>();
  const [loading, setLoading] = useState(true);

  const fetchAnnualReviews = async () => {
    setLoading(true);
    const { data, error } = await getAllAnnualReviewCycles('hr');
    setLoading(false);
    if (error) return myRef.current?.call('error', error?.message);
    if (data) {
      setData(data);
    }
  };

  useEffect(() => {
    fetchAnnualReviews();
  }, []);

  const handleEditClick = (data: AnnualReviewCycle) => {
    setEditID(data?.id);
    setOpen(true);
  };

  return (
    <div className="flex flex-col gap-y-[10px]">
      <div className="p-[10px] flex flex-col gap-y-[10px]">
        <div className="flex py-[10px]">
          <div>
            <div className="text-[20px] font-[500]">All Annual Reviews</div>
            <div className="opacity-45">
              View, edit, and manage existing annual review cycles effortlessly.
            </div>
          </div>

          <div className="ml-auto">
            <Button
              type="primary"
              onClick={() =>
                navigate(
                  Paths.HRAllAnnualReviews + '/create-annual-review-cycle'
                )
              }
            >
              Create New Review Cycle
            </Button>
          </div>
        </div>
      </div>
      <Table
        columns={Columns(handleEditClick)}
        data={data}
        errorFetchingData={false}
        loading={loading}
        rowKey="id"
      />
      <Modal
        title={
          <div className="text-[20px] font-[500]">Edit Annual Review Cycle</div>
        }
        centered
        open={open}
        onOk={() => setOpen(false)}
        onCancel={() => setOpen(false)}
        width={1024}
        footer={<></>}
        destroyOnClose
      >
        <CreateEditAnnualReview
          editID={editID}
          setOpen={setOpen}
          fetchData={fetchAnnualReviews}
        />
      </Modal>
      <NotificationAlert ref={myRef} />
    </div>
  );
};

export default AllAnnualReviewCycles;
